import * as React from "react";
import styled, { css } from "styled-components";

const StyledPanel = styled.div<IPanelProps>`
  background-color: ${({ theme }) => theme.colors.blueDarker3};
  border: ${({ theme }) => theme.borders[3]};
  border-radius: ${({ theme }) => theme.radii[2]};

  ${({ $isFullHeight = false }) =>
    $isFullHeight &&
    css`
      height: 100%;
    `}
`;

const StyledPanelHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[2]};
  border-top-left-radius: ${({ theme }) => theme.radii[2]};
  border-top-right-radius: ${({ theme }) => theme.radii[2]};
  background-color: ${({ theme }) => theme.colors.primary};
`;

const PanelHeading = styled.h4`
  flex: 1;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.base};
`;

const StyledPanelFooter = styled.div`
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[2]}`};
  border-top: ${({ theme }) => theme.borders[3]};
  text-align: center;
`;

interface IPanelHeaderProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

const PanelHeader: React.FC<IPanelHeaderProps> = ({ children, title }) => (
  <StyledPanelHeader>
    <PanelHeading>{title}</PanelHeading>
    {children}
  </StyledPanelHeader>
);

interface IPanelBodyProps {
  children: React.ReactNode;
}

const PanelBody: React.FC<IPanelBodyProps> = ({ children }) => (
  <div>{children}</div>
);

interface IPanelFooterProps {
  children: React.ReactNode;
}

const PanelFooter: React.FC<IPanelFooterProps> = ({ children }) => (
  <StyledPanelFooter>{children}</StyledPanelFooter>
);

interface IPanelProps {
  children?: React.ReactNode;
  hasKeyline?: boolean;
  $isFullHeight?: boolean;
}

const Panel = ({ children, $isFullHeight = false }: IPanelProps) => {
  return <StyledPanel $isFullHeight={$isFullHeight}>{children}</StyledPanel>;
};

Panel.Header = PanelHeader;
Panel.Body = PanelBody;
Panel.Footer = PanelFooter;

export default Panel;
